import contractCreatedFormDictionary from '@widgets/contract-created-form/i18n/ru/contract-created-form.dic.json';

export const contractCreatedForm = {
  CONTRACT_CREATED_FORM: contractCreatedFormDictionary,
};

export const contractCreatedFormNamespaces = ['CONTRACT_CREATED_FORM'];
